import { Upload } from "antd";
import { API_BASE_URL } from "configs/AppConfig";
import React, { useState } from "react";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import uploadFileService from "services/UploadFileService";

function UploadUnico({ value, onChange, onBlur, ...props }) {
	const [loading, setLoading] = useState(false);

	const uploadButton = (
		<div>
			{loading ? <LoadingOutlined /> : <PlusOutlined />}
			<div style={{ marginTop: 8 }}>Carregar</div>
		</div>
	);

	const beforeUpload = (file) => {
		const isImage = file.type.startsWith("image/");
		if (!isImage) {
			message.error("Você só pode enviar arquivos de imagem!");
		}
		return isImage || Upload.LIST_IGNORE; // Impede o upload se não for imagem
	};

	return (
		<div
			tabIndex={0} // Permite que o contêiner receba foco
			onBlur={() => {
				if (onBlur) {
					onBlur();
				}
			}}
		>
			<Upload
				action={`${API_BASE_URL}/v1/rest/upload-file`}
				listType="picture-card"
				className="avatar-uploader"
				maxCount={1}
				showUploadList={false}
				beforeUpload={beforeUpload}
				customRequest={async (options) => {
					const formData = new FormData();
					formData.append("file", options.file);

					onChange(null);
					setLoading(true);

					const response = await uploadFileService.create(formData);

					options.onSuccess(response.link);

					onChange(response.link);
					if (onBlur) {
						onBlur();
					}
					setLoading(false);
				}}
				fileList={value ? [{ status: "done", url: value }] : []}
				onRemove={() => {
					onChange(null);
					if (onBlur) {
						onBlur();
					}
				}}
				{...props}
			>
				{value ? (
					<img src={value} alt="avatar" style={{ width: "100%" }} />
				) : (
					uploadButton
				)}
			</Upload>
		</div>
	);
}

export default UploadUnico;
